export enum LogoEnum {
  'logo-docmagic' = 'logo-docmagic',
}

export type LogoType = `${LogoEnum}`;
export const LogoList = Object.keys(LogoEnum) as LogoEnum[];
